import {
  isString,
  isFunction,
} from 'lodash';

export function getErrorMessage(error: any) {
  if (error) {
    if (isString(error)) {
      return error;
    }

    if (isFunction(error.get)) {
      if (error.get('message') && error.get('status')) {
        return `HTTP ${error.get('status')} - ${error.get('message')}`;
      }
      if (error.get('message')) {
        return error.get('message');
      }
      if (error.get('error')) {
        return error.get('error');
      }
      if (error.get('reason')) {
        return `${error.get('error')} - ${error.get('reason')}`;
      }

      return JSON.stringify(error);
    }

    if (error.message && error.body && error.status) {
      return `HTTP ${error.status} - ${error.message}\n[${error.body}]`;
    }
    if (error.message && error.status) {
      return `HTTP ${error.status} - ${error.message}`;
    }
    if (error.message) {
      return error.message;
    }
    if (error.error) {
      return error.error;
    }
    if (error.reason) {
      return `${error.error} - ${error.reason}`;
    }

    return JSON.stringify(error);
  }
  return 'Unknown error';
}
